import * as React from 'react';
import { showModal } from '@/store/reducers/ui-slice';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link as LinkIcon } from '@phosphor-icons/react/dist/ssr/Link';
import { Trash as TrashIcon } from '@phosphor-icons/react/dist/ssr/Trash';
import { useDispatch } from 'react-redux';

import { ModalDrawer } from '@/types/general';

export interface ItemMenuProps {
  anchorEl?: HTMLElement | null;
  onClose?: () => void;
  onDelete?: () => void;
  open?: boolean;
  mediaId?: string;
  path: string;
}

export function ItemMenu({ anchorEl, onClose, open = false, mediaId, path }: ItemMenuProps): React.JSX.Element {
  const dispatch = useDispatch();
  const handleCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(`${process.env.NEXT_PUBLIC_CMS_V2_IMAGES_URL}${path}`);
    } catch (err) {
      // console.error('Error copying text to clipboard', err);
    }

    onClose?.();

    // setTimeout(() => {
    //   setCopiedStates((prev) => prev.map((copied, i) => (i === index ? false : copied)));
    // }, 2000);
  };

  const handleDelete = async (): Promise<void> => {
    dispatch(
      showModal({
        open: ModalDrawer.DELETE_MEDIA_ITEM,
        content: {
          mediaId,
          path,
        },
      })
    );

    onClose?.();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      onClose={onClose}
      open={open}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
    >
      <MenuItem onClick={handleCopy}>
        <ListItemIcon>
          <LinkIcon />
        </ListItemIcon>
        Copy Link
      </MenuItem>
      <MenuItem onClick={handleDelete} sx={{ color: 'var(--mui-palette-error-main)' }}>
        <ListItemIcon>
          <TrashIcon />
        </ListItemIcon>
        Delete
      </MenuItem>
    </Menu>
  );
}
